// extracted by mini-css-extract-plugin
module.exports = {"header":"ProductsInvoiceEditor_header__2wS4e","menu":"ProductsInvoiceEditor_menu__3ysds"};